import {Component, OnDestroy} from '@angular/core';
import {FiltersService} from "../../filters/filters.service";
import {AppConfig} from '../../../../config/app-config';
import {AppConfigService} from '../../../../config/app-config.service';
import {TranslateService} from '../../../../shared/translate.service';

@Component({
  selector: 'app-choosen-filters',
  templateUrl: './choosen-filters.component.html',
  styleUrls: ['./choosen-filters.component.css']
})
export class ChoosenFiltersComponent{

  constructor(
    public filtersService: FiltersService,
    public appConfigService: AppConfigService,
    public translateService: TranslateService) {
  }

}
